
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileText, AlertCircle } from "lucide-react";
import { ImportFormat } from "./types";

interface ImportFormProps {
  importFormat: ImportFormat;
  importText: string;
  onFormatChange: (value: string) => void;
  onTextChange: (value: string) => void;
  loadExample: () => void;
}

const ImportForm: React.FC<ImportFormProps> = ({
  importFormat,
  importText,
  onFormatChange,
  onTextChange,
  loadExample
}) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="import-format">Format</Label>
        <Select 
          value={importFormat} 
          onValueChange={onFormatChange}
        >
          <SelectTrigger id="import-format" className="w-full md:w-40">
            <SelectValue placeholder="Select format" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="json">JSON</SelectItem>
            <SelectItem value="csv">CSV</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <Label htmlFor="import-data">Paste your data below</Label>
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-7 gap-1 text-xs"
            onClick={loadExample}
          >
            <FileText className="h-3 w-3" />
            Load Example
          </Button>
        </div>
        <Textarea
          id="import-data"
          value={importText}
          onChange={(e) => onTextChange(e.target.value)}
          className="font-mono text-sm min-h-[300px]"
        />
      </div>

      {importFormat === "csv" && (
        <div className="text-sm bg-amber-50 border border-amber-200 rounded-md p-3 flex items-start gap-2">
          <AlertCircle className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
          <div>
            <p className="font-medium text-amber-700">CSV Format Note</p>
            <p className="mt-1 text-amber-600">
              For the "required_items" column, separate multiple items with semicolons (;)
              instead of commas to avoid breaking the CSV format.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImportForm;
